import React from "react";

export const CompanentNoRigthLicCardCompany = ({ children }) => {
  return (
    <div className="card_company_block_lic_no_rigth">
      <p className="company_card_block_lic_text">{children}</p>
    </div>
  );
};
